import './App.css';
import Home from './components/Home/Home';

function App() {
  return (
    <div className="max-w-[1440px] mx-auto dark:text-white bg-[#1E1E1E] dark:bg-[#1E1E1E] font-nunito">
      <Home></Home>
    </div>
  );
}

export default App;
